import React from 'react';
import { Box, Container } from '@qga/roo-ui/components';

import ConditionsMarkdown from '@/components/ConditionsMarkdown';
import Heading from '@/components/Heading';
import useDestination from '@/hooks/useDestination';
import { useDestination as v2UseDestination } from '@/v2/contexts/destination';

const Description = () => {
  const d = useDestination();
  const dV2 = v2UseDestination();

  const destination = d || dV2;

  return (
    <Box bg="background.card" py="12" mt="3">
      <Container maxWidth="830px">
        <Heading.h2
          textAlign={['left', null, 'center']}
          fontSize={['md', null, '2xl']}
        >
          {destination.theme ? '' : 'Discover '}
          {destination.title}
        </Heading.h2>
        <Box my="4">
          <ConditionsMarkdown markdown={destination.description} />
        </Box>
      </Container>
    </Box>
  );
};

export default Description;
